<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'EventStatusInput',
    components: {
        Multiselect,
    },
    props: {
        initialValue: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        saveButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: null,
            options: [],
        };
    },
    computed: {
        selected: {
            get() {
                if (!this.value && this.initialValue) {
                    return this.options.find(option => option.id === parseInt(this.initialValue, 10));
                }

                return this.value;
            },
            set(val) {
                this.value = val;
                this.$emit('input', val);
            },
        },
    },
    async mounted() {
        await this.getEventStatuses();
    },
    methods: {
        async getEventStatuses() {
            this.options = await this.$store.cache.dispatch('selects/getEventStatuses');
        },
        focusSelect() {
            this.$refs.select.$el.focus();
        },
    },
};
</script>

<template>
    <div>
        <div class="d-flex justify-content-center align-items-center mb-2">
            <Multiselect
                ref="select"
                v-model="selected"
                :options="options"
                track-by="id"
                label="name"
                select-label="⏎"
                selected-label=""
                :multiple="false"
            />
            <button
                v-if="saveButton"
                type="submit"
                class="btn btn-primary"
            >
                <i class="fa fa-save" />
            </button>
            <input
                v-if="selected"
                :name="name"
                type="hidden"
                :value="selected.id"
            >
        </div>
        <div
            v-if="selected && selected.message"
            class="alert alert-danger"
        >
            <div v-html="selected.message" />
        </div>
    </div>
</template>

<style
    scoped
    lang="scss"
>

.alert-dismissible {
    padding-right: 1.25rem;
    padding-top: 2.5rem;
}
</style>
